import { ProgramSelectionForm } from "@/components/domain/care-plan/ProgramSelectionForm";
import type { ProgramSelectionFormData } from "@benchmark/core/types";

/**
 * Props for enrollment step section.
 * @agentic connections
 */
export type EnrollmentSectionProps = {
  onSubmit: (data: ProgramSelectionFormData | undefined) => void;
  initialValues?: Partial<ProgramSelectionFormData>;
};

/**
 * Enrollment step for selecting operational care plan program.
 * @agentic connections
 */
export const EnrollmentSection = ({
  onSubmit,
  initialValues,
}: EnrollmentSectionProps) => (
  <ProgramSelectionForm
    onSubmit={onSubmit}
    submitting={false}
    error={null}
    initialValues={initialValues}
  />
);
